// Ein Datum ('YYYY-MM-DD') in der aktiven Sprache ausschreiben.
//
// Das Muster gehört zur Sprache, nicht zum Code: „7. September 2026" ist
// deutsch, „7 September 2026" englisch, „7 de septiembre de 2026" spanisch.
// (Dieselbe Überlegung steckt in SmartAIBookingFlow.tsx; hier für die
// Urlaubs-Hinweise, die auf jeder Seite stehen können.)

import { format, parseISO, isValid } from 'date-fns';
import { de, enUS, es, ru } from 'date-fns/locale';

const LOCALES: Record<string, typeof de> = { de, en: enUS as typeof de, es, ru };

const PATTERNS: Record<string, string> = {
  de: 'd. MMMM yyyy',
  en: 'd MMMM yyyy',
  es: "d 'de' MMMM 'de' yyyy",
  ru: 'd MMMM yyyy',
};

/**
 * @returns das ausgeschriebene Datum, oder den Eingabewert unverändert, wenn
 *          er kein brauchbares Datum ist — ein Hinweis mit rohem ISO-Datum ist
 *          immer noch besser als „Invalid Date" auf der Startseite.
 */
export function formatLongDate(iso: string, language: string): string {
  if (!iso) return '';
  const d = parseISO(iso);
  if (!isValid(d)) return iso;
  return format(d, PATTERNS[language] || PATTERNS.de, { locale: LOCALES[language] || de });
}
